/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {AuthenticationService} from "./authentication.service";
import {Injectable} from "@angular/core";

@Injectable()
export class StartupService {

  constructor(
    private mAuthenticationService: AuthenticationService
  ) {}

  public async initialize(): Promise<void> {
    console.log("Beginning Startup...");

    //Initialize the Authorization Service so that if a User was previously logged in, they can continue to be logged in
    await this.mAuthenticationService.initialize();

    console.log("Startup Finished!");
  }

}
